//
//
//
//
//
//
export default {
  name: 'app',
  created: function created() {
    var scene = this.$route.query.scene;

    if (scene === 'kscoin_charge') {
      document.title = '快币充值';
    }
  }
};